import React from 'react'

const FenwickTree = () => {
  return (
    <div>
        <iframe src="https://www.visualgo.net/en/fenwicktree"
            width={window.innerWidth}
            height='920px'
            allow="autoplay"
            loading="lazy"
            title='FenwickTree'
        />
    </div>
  )
}

export default FenwickTree

// link: "https://www.visualgo.net/en/fenwicktree",